import { ApiReferenceReact } from '@scalar/api-reference-react'
import '@scalar/api-reference-react/style.css'

import React from 'react'

import useTheme from 'src/hooks/utils/useTheme'

const ApiReference: React.FC = () => {
  const theme = useTheme()

  return (
    <div className="mx-4 mb-10 mt-4 xs:mx-10">
      <div className="border border-th-border">
        <ApiReferenceReact
          configuration={{
            url: window.config.publicOpenApiSpecUrl,
            forceDarkModeState: theme === 'dark' ? 'dark' : 'light',
            hideDarkModeToggle: true,
            hideClientButton: true,
            customCss: '',
            authentication: {
              securitySchemes: {
                OAuth2: {
                  flows: {
                    clientCredentials: {
                      selectedScopes: [`https://${window.config.authorityDomain}/provide-api/.default`]
                    }
                  }
                }
              }
            }
          }}
        />
      </div>
    </div>
  )
}

export default ApiReference
